import React, {useState} from 'react';

import {
  Button,
  Flex,
  Text,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react"

import { Eye, EyeOff } from 'react-feather';

export default function Credentials({
  funcToRun, 
  displayText,  
}){
  
const [username, setUsername] = useState('')  
const [password, setPassword] = useState('')
const handleUsername = setValue => e => setValue(e.target.value)
const handlePassword = setValue => e => setValue(e.target.value)
const [showPassword, setShowPassword] = useState(false);

const handleShowPassword = () => setShowPassword(!showPassword);
  return (
      <form onSubmit={funcToRun} >
        <Flex mt={10} h={100} flexDirection="column" justifyContent="space-between" alignItems="center">
          <Flex justifyContent="center" alignItems="center">
            <Input 
                mr={3}
                placeholder="username" 
                variant="flushed" 
                type="text" 
                value={username}
                onChange={handlePassword(setUsername)}
                isRequired={true}
            />
            <InputGroup mr={6}>
                <Input 
                    placeholder="password" 
                    variant="flushed" 
                    type={showPassword ? "text" : "password"} 
                    value={password}  
                    onChange={handleUsername(setPassword)}
                    isRequired={true}
                />
                <InputRightElement width="1rem" onClick={handleShowPassword} style={{cursor: 'pointer'}}>
                    <Icon as={showPassword ? Eye : EyeOff} w={4} h={4}/>
                </InputRightElement>
            </InputGroup>
            
          
          </Flex>
          <Button mt={15} w={100} colorScheme="blue" type="submit" variant="solid" size="xs" p={5} onClick={(e) =>{
              e.preventDefault();
              funcToRun(username, password)
            }}><Text fontSize="md">{displayText}</Text>
          </Button>
        </Flex>
      </form>
  )
}